import http from "infra/http";
import { useQuery } from "react-query";
import { NotificacaoProviderListResponse } from "../typings";

function useNotificacaoProviders() {
  return useQuery([`/v1/notificacao-cobranca/providers`], async () => {
    const { data } = await http.get<NotificacaoProviderListResponse[]>(
      `/v1/notificacao-cobranca/providers`
    );
    return data;
  });
}

export default useNotificacaoProviders;
